import { useEffect } from 'react'

const InovaTool = ({ sku }: { sku: string }) => {
  useEffect(() => {
    let intervalID: NodeJS.Timer

    const initInova = () => {
      intervalID = setTimeout(() => {
        if (window.cls_InovaDiamonds_Iframe) {
          try {
            window.cls_InovaDiamonds_Iframe.init_Session_Go('after')
          } catch (error) {
            console.error('An error occurred when initiating AR')
          }
          clearInterval(intervalID)
        }
      }, 2000)
    }

    initInova()

    return () => {
      clearInterval(intervalID)
    }
  }, [])

  return (
    <div id="AR-thumbnail">
      <h4 className="h-0">{sku}</h4>
    </div>
  )
}

export default InovaTool
